import { INir } from '@Components/index'

export class Nir {

  public static createDefaultNir(): INir {
		return {id: '-1', number: '', iso: 'fr', error: false}
	}
}